import { FC } from "react";
import { Navigation, Section } from "../../../@component/layout";
import { Button } from "../../../@component/buttons";
import { Program } from "../../../@component/sections/program";
import { Impact } from "../../../@component/sections/impact";
import { Location } from "../../../@component/sections/locations";
import { Footer } from "../../../@component/layout/footer";
import { AboutFounder } from "../../../@component/sections/about-founder";
export const AboutPage: FC = (props) => {
  return (
    <Section>
      <Navigation>
        <Button>hallo</Button>
      </Navigation>
      <AboutFounder />
      <Program />
      <Impact />
      <Location />
      <Footer />
    </Section>
  );
};
